import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import InputRejected from '../InputRejected';

import { isValidDigitNumber } from './validator';
// eslint-disable-next-line import/no-named-as-default
import numberFormatter from './formatter';

// eslint-disable-next-line react/prop-types
const InputNumber = ({
  value,
  onChange,
  isEmpty,
  onKeyDown,
  isFloat,
  ...props
}) => {
  const handleOnChange = useCallback((event) => {
    const { value: _value } = event.target;
    const newValue = numberFormatter(_value, isFloat);
    onChange(event, newValue);
  }, [onChange, isFloat]);

  const handleOnKeyDown = useCallback((event) => {
    const charCode = event.which ? event.which : event.keyCode;
    const ctrlCode = event.ctrlKey ? event.ctrlKey : event.metaKey;
    const { value: _value } = event.target;
    if (!isValidDigitNumber(charCode, ctrlCode, _value)) event.preventDefault();
  }, []);

  return (
    <InputRejected
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      value={numberFormatter(value, isFloat)}
      onChange={handleOnChange}
      isEmpty={isEmpty}
      typeValidation="number"
      onKeyDown={handleOnKeyDown}
    />
  );
};

InputNumber.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  isFloat: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  isEmpty: PropTypes.any,
};

InputNumber.defaultProps = {
  isFloat: true,
  isEmpty: undefined,
};

export default memo(InputNumber);
